import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import {
  AgentInvitationSetup,
  ResetPassword,
  VerifyEmail,
} from "./components/Auth";
import { PaymentSuccess } from "./components/PaymentSuccess";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { TermsUser } from "./components/TermsUser";
import { TermsBusiness } from "./components/TermsBusiness";
import { TermsTrainer } from "./components/TermsTrainer";
import { TermsBooking } from "./components/TermsBooking";
import { AccountDeletion } from "./components/AccountDeletion";
import { Contact } from "./components/Contact";
import { BookBusiness } from "./components/BookBusiness";
import { ProductDeepLink } from "./components/ProductDeepLink";
import { GroupActivityDeepLink } from "./components/GroupActivityDeepLink";
import { TrainerAssociationConfirm } from "./components/TrainerAssociationConfirm";
import { BusinessParentChildConfirm } from "./components/BusinessParentChildConfirm";
import { Landing } from "./components/Landing";

const BUSINESS_APP_URL = "https://business.spotto.pl";

function ExternalRedirect({ path }: { path: string }) {
  useEffect(() => {
    window.location.replace(`${BUSINESS_APP_URL}${path}`);
  }, [path]);

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      padding: "24px",
      fontFamily: "system-ui, sans-serif",
      color: "#e5e5e5",
      backgroundColor: "#0f0f10",
      textAlign: "center",
    }}>
      <div>
        <p style={{ fontSize: "16px", marginBottom: "12px" }}>
          Przekierowanie do portalu biznesowego…
        </p>
        <a
          href={`${BUSINESS_APP_URL}${path}`}
          style={{ color: "#4da3ff", textDecoration: "underline" }}
        >
          Kliknij tutaj, jeśli nie nastąpi automatyczne przekierowanie.
        </a>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            {/* Landing */}
            <Route path="/" element={<Landing />} />

            {/* Moved to business.spotto.pl — redirect existing bookmarks */}
            <Route path="/login" element={<ExternalRedirect path="/login" />} />
            <Route path="/forgot-password" element={<ExternalRedirect path="/forgot-password" />} />
            <Route path="/register/agent" element={<ExternalRedirect path="/register/agent" />} />
            <Route path="/register/business" element={<ExternalRedirect path="/register/business" />} />
            <Route path="/setup/business-profile" element={<ExternalRedirect path="/setup/business-profile" />} />
            <Route path="/settings/business-profile" element={<ExternalRedirect path="/settings/business-profile" />} />

            {/* Callback / deep-link routes — must keep working on spotto.pl */}
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/invitation/:token" element={<AgentInvitationSetup />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/regulamin-uzytkownika" element={<TermsUser />} />
            <Route path="/regulamin-obiektu" element={<TermsBusiness />} />
            <Route path="/regulamin-trenera" element={<TermsTrainer />} />
            {/* Warunki rezerwacji i zakupu — świadomie ukryte: brak linku
                w nawigacji/stopce, strona ustawia robots: noindex. Dostępne
                po bezpośrednim URL (docelowo linkowane z pluginu Commerce). */}
            <Route path="/warunki-rezerwacji-i-zakupu" element={<TermsBooking />} />
            <Route path="/delete-account" element={<AccountDeletion />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book/:businessId" element={<BookBusiness />} />
            <Route path="/product/:productId" element={<ProductDeepLink />} />
            <Route path="/sparing/:activityId" element={<GroupActivityDeepLink />} />
            <Route path="/trainer-association/:token" element={<TrainerAssociationConfirm />} />
            <Route path="/business-association/:token" element={<BusinessParentChildConfirm />} />

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
